export const TRENDS = {
  increasing: "Increasing",
  decreasing: "Decreasing",
  maintaining: "Maintaining",
  pending: "Pending",
};
